import { createContext, useContext, useState } from 'react';

const SearchContext = createContext();

export function SearchProvider({ children }) {
  const [globalSearchQuery, setGlobalSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const performSearch = (query) => {
    // Define your searchable items (sidebar menu items and profile data)
    const searchableItems = [
      { type: 'menu', title: 'Dashboard', path: '/dashboard' },
      { type: 'menu', title: 'Agencies', path: '/agencies' },
      { type: 'menu', title: 'NPOs', path: '/npos' },
      { type: 'menu', title: 'Profile', path: '/update-user' },
      { type: 'menu', title: 'Tasks', path: '/tasks' },
      { type: 'menu', title: 'Agency Management', path: '/agency-management' },
      { type: 'menu', title: 'Team User Management', path: '/team-user-management' },
      { type: 'menu', title: 'Agency User', path: '/agency-user' },
      { type: 'menu', title: 'Create Agency', path: '/create-agency' },
      { type: 'menu', title: 'Create NPO', path: '/create-npo' },
      { type: 'menu', title: 'Create Team', path: '/create-team' },
      { type: 'menu', title: 'Create User', path: '/create-user' },
      { type: 'menu', title: 'Modify Team', path: '/modify-team' },
      { type: 'menu', title: 'Event Management', path: '/event-management' },
    ];

    // Also add search functionality for data within pages
    const searchableData = {
      'user-management': {
        fields: ['company_name', 'email', 'phone', 'country'],
        reference: 'src/pages/userManagement/UserManagement.js',
        startLine: 15,
        endLine: 22
      },
      'agencies': {
        fields: ['company_name', 'email'],
        reference: 'src/pages/agencies/Agencies.js',
        startLine: 230,
        endLine: 231
      },
      'npos': {
        fields: ['company_name', 'email', 'phone', 'country'],
        reference: 'src/pages/npos/Npos.js',
        startLine: 186,
        endLine: 189
      }
    };

    if (query.trim() === '') {
      setSearchResults([]);
      return;
    }

    const results = searchableItems.filter(item =>
      item.title.toLowerCase().includes(query.toLowerCase())
    );

    setSearchResults(results);
  };

  return (
    <SearchContext.Provider value={{ 
      globalSearchQuery, 
      setGlobalSearchQuery, 
      searchResults, 
      performSearch 
    }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => useContext(SearchContext); 